import {NewsEntry} from 'Agent/AgentInformation/models/NewsEntry';
import {AsyncPage, Empty, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';

export enum AgentNewsActionType {
  GET_NEWS = 'news/GET_NEWS',
  LOAD_NEWS = 'news/LOAD_NEWS',
}

export const getNews = (page?: Page<NewsEntry>) => createAction(AgentNewsActionType.GET_NEWS, {page});
export const loadNews = (news: AsyncPage<Page<NewsEntry>>) => createAction(AgentNewsActionType.LOAD_NEWS, {news});

type AgentNewsState = AsyncPage<Page<NewsEntry>>;

const DEFAULT_STATE = new Empty();

type AgentNewsAction = ReturnType<typeof loadNews> | ReturnType<typeof getNews>;

export default (state: AgentNewsState = DEFAULT_STATE, action: AgentNewsAction): AgentNewsState => {
  switch (action.type) {
    case AgentNewsActionType.GET_NEWS:
      const {page} = action.payload;
      return page ? new LoadingAdditional(page) : new Loading(page);
    case AgentNewsActionType.LOAD_NEWS:
      return action.payload.news;
    default:
      return state;
  }
};
